import { useEffect, useState } from "react";

export default function useCheckedWorkers(workers, selectWorkers) {

    const [check, setCheck] = useState(workers.length == selectWorkers.length);

    useEffect(() => {
        setCheck(workers.length == selectWorkers.length);
    }, [workers, selectWorkers]);

    return check;
}